import { React, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import "./kvkk.css"; // Reusing the same CSS for consistent design
import Header2 from "../../header2/index-two";
import { Footer2 } from "../../footer2";
import usePageTracking from '../../../hooks/usePageTracking';

const ParticipationAgreement = () => {
  usePageTracking("participation-agreement");
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
  }, [pathname]);

  return (
    <div className="main-wrapper">
      <Header2 />
      {/* ======================================================= */}
      {/* İDEALONLİNE DİJİTAL KATILIM SÖZLEŞMESİ */}
      {/* ======================================================= */}
      <section className="kvkk-section">
        <div className="kvkk-container">
          <div className="kvkk-background">
            <div className="kvkk-inner">
              <div className="kvkk-heading">
                <h2>İDEALONLİNE DİJİTAL KATILIM SÖZLEŞMESİ</h2>
                <h4 className="mt-2 text-secondary">YAYIN PLATFORMU KATILIM SÖZLEŞMESİ</h4>
              </div>
            </div>
          </div>
        </div>

        <div className="kvkk-content mb-5">
          <h3 className="kvkk-section-title">1. TARAFLAR VE ONAY</h3>
          <p className="kvkk-paragraph">
            İşbu Sözleşme; bir tarafta İdeal Kültür Yayıncılık Reklam ve Organizasyon San. Tic. Ltd. Şti. (Bundan sonra “İDEAL KÜLTÜR” olarak anılacaktır) ile diğer tarafta, başvuru formundaki bilgileri beyan eden ve bu Sözleşmeyi dijital ortamda onaylayan YAYINCI arasında akdedilmiştir. Yayıncı, "Okudum, onaylıyorum" kutucuğunu işaretleyerek Sözleşme hükümlerini bütünüyle kabul etmiş sayılır.
          </p>
          <h3 className="kvkk-section-title">2. SÖZLEŞMENİN KONUSU VE KAPSAMI</h3>
          <p className="kvkk-paragraph">
            <strong>2.1. Konu:</strong> Yayıncı’nın telif haklarına sahip olduğunu beyan ettiği matbu veya dijital eserlerin, İDEAL KÜLTÜR tarafından işletilen elektronik veri tabanı platformuna dahil edilmesidir.
          </p>
          <p className="kvkk-paragraph">
            <strong>2.2. Kullanım Hakkı:</strong> YAYINCI, eserlerin platformda dijital ortamda yayınlanması amacıyla İDEAL KÜLTÜR’e münhasır olmayan, devredilemez ve alt lisans verilemez bir kullanım hakkı tanır.
          </p>
          <p className="kvkk-paragraph">
            <strong>2.3. Münhasır Olmama:</strong> İşbu Sözleşme münhasır nitelikte değildir; YAYINCI, eserlerini başka platformlarda yayınlamakta serbesttir.
          </p>

          <h3 className="kvkk-section-title">3. MALİ HÜKÜMLER</h3>
          <p className="kvkk-paragraph">
            İşbu Sözleşme kapsamında YAYINCI’ya herhangi bir telif, lisans bedeli veya ücret ödenmeyecektir. Eserlerin İDEAL KÜLTÜR platformuna dahil edilme işlemi ücretsizdir. Taraflar, bu iş birliğinden doğan karşılıklı tanıtım ve erişilebilirlik faydasını yeterli kabul ederler.
          </p>

          <h3 className="kvkk-section-title">4. YAYIN BİLGİLERİ VE KAYIT ESASLARI</h3>
          <p className="kvkk-paragraph">
            Sisteme dahil edilecek yayınların (Dergi Adı, ISSN, Periyot, Editör Bilgileri vb.) detayları, YAYINCI tarafından başvuru ekranında doldurulan form verileri esas alınarak belirlenir. Bilgi değişikliklerini bildirmek YAYINCI sorumluluğundadır.
          </p>

          <h3 className="kvkk-section-title">5. TARAFLARHIN HAK VE YÜKÜMLÜLÜKLERİ</h3>
          <p className="kvkk-paragraph">
            <strong>5.1. Yayın Taahhüdü:</strong> İDEAL KÜLTÜR, YAYINCI’ya ait eserleri elektronik veri tabanına eklemeyi ve platform standartları dahilinde erişime sunmayı kabul eder.
          </p>
          <p className="kvkk-paragraph">
            <strong>5.2. Gizlilik:</strong> İDEAL KÜLTÜR, taraflar arasındaki her türlü ticari ve kurumsal bilgiyi gizli tutmayı; YAYINCI’nın yazılı onayı olmaksızın üçüncü şahıslara açıklamamamayı taahhüt eder.
          </p>
          <p className="kvkk-paragraph">
            <strong>5.3. İçerikten Çıkarma:</strong> YAYINCI’nın yayının kaldırılmasını talep etmesi durumunda; güncel sayı girişleri durdurulur, geçmiş sayılar ise sistem işleyişini aksatmayacak şekilde kademeli olarak sistemden çıkarılır. Künye bilgileri indeksleme gereği açık kalmaya devam edebilir.
          </p>
          <p className="kvkk-paragraph">
            <strong>5.4. Telif ve Sorumluluk:</strong> YAYINCI, ilettiği yayınların tüm telif haklarına sahip olduğunu beyan eder. Telif haklarıyla ilgili oluşabilecek her türlü hukuki ihtilaf ve zarardan doğrudan YAYINCI sorumludur.
          </p>

          <h3 className="kvkk-section-title">6. KİŞİSEL VERİLERİN KORUNMASI (KVKK)</h3>
          <p className="kvkk-paragraph">
            Taraflar, kişisel verilerin 6698 sayılı KVKK uyarınca işleneceğini kabul eder. İDEAL KÜLTÜR, sözleşme ifası ve bilgilendirme amaçlı olarak YAYINCI iletişim bilgilerini kullanabilir. YAYINCI, sisteme yüklediği içeriklerdeki kişisel verilerin hukuka uygun elde edildiğini beyan eder.
          </p>

          <h3 className="kvkk-section-title">7. TEBLİGAT VE YETKİLİ MAHKEME</h3>
          <p className="kvkk-paragraph">
            <strong>7.1. Tebligat:</strong> Sistemde beyan edilen e-posta ve fiziki adresler geçerli tebligat adresleridir.
          </p>
          <p className="kvkk-paragraph">
            <strong>7.2. Yetkili Mahkeme:</strong> Uyuşmazlıkların çözümünde İstanbul (Çağlayan) Mahkemeleri ve İcra Daireleri münhasıran yetkilidir.
          </p>

          <h3 className="kvkk-section-title">8. ELEKTRONİK ONAY, DELİL SÖZLEŞMESİ VE YÜRÜRLÜK</h3>
          <p className="kvkk-paragraph">
            İşbu Sözleşme, YAYINCI’nın elektronik ortamda “Okudum, onaylıyorum” ibaresini işaretlemesi ile yürürlüğe girer. Taraflar, elektronik ortamda verilen onayın geçerli ve bağlayıcı olduğunu; İDEAL KÜLTÜR’e ait sistem kayıtları, log kayıtları, IP verileri ve elektronik onay verilerinin 6100 sayılı HMK m.193 kapsamında yazılı delil niteliğinde olduğunu kabul ve beyan ederler.
          </p>
        </div>
      </section>
      <Footer2 />
    </div>
  );
};

export default ParticipationAgreement;
